module.exports = __webpack_public_path__ + "e529de3b64b4c26cded5af02df4fef0d.otf";